// Our import.meta.dev, extended to the deployed environments a build cannot tell apart.
export const useMetaDevelopment = () => useNuxtApp().$appConfig.app?.isDevelopment !== false;
